<div class="terms">
    <!-- On the waves: the language and the way out (which declines the terms). -->
    <div class="terms__tools">
        <app-language-selector></app-language-selector>
        <p-button
            icon="ms ms-close"
            severity="secondary"
            [rounded]="true"
            [ariaLabel]="'common.close_button' | translate"
            (onClick)="closeDialog(false)" />
    </div>
    <div class="wave-content">
        <svg
            class="element-3"
            width="521"
            height="136"
            viewBox="0 0 521 136"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M274.314 90.7624C391.671 78.5635 487.67 115.838 521 136L521 0.795639L1.18199e-05 0.795593L8.1762e-06 42.4751C42.5396 63.6538 156.958 102.961 274.314 90.7624Z"
                [attr.fill]="mainColor"
                opacity="0.6" />
        </svg>
        <svg
            class="element-2"
            width="521"
            height="136"
            viewBox="0 0 521 136"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M274.314 90.3659C391.671 78.1671 487.67 115.441 521 135.604L521 0.399155L1.18199e-05 0.399109L8.1762e-06 42.0787C42.5396 63.2573 156.958 102.565 274.314 90.3659Z"
                [attr.fill]="mainColor"
                opacity="0.8" />
        </svg>

        <svg
            class="element-1"
            width="521"
            height="136"
            viewBox="0 0 521 136"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M274.314 89.9656C391.671 77.7667 487.67 115.041 521 135.203L521 -0.00123596L1.18199e-05 -0.00128151L8.1762e-06 41.6783C42.5396 62.8569 156.958 102.164 274.314 89.9656Z"
                [attr.fill]="mainColor" />
        </svg>
    </div>
    <div class="terms__content">
        <h2 [innerHTML]="'home.terms.title' | translate"></h2>
        <p>
            {{ 'home.terms.paragraph1' | translate }}
        </p>
        <p>
            <a class="text-link" [href]="termsUrl" target="_blank">{{ 'home.terms.paragraph2' | translate }}</a>
        </p>

        <p>
            {{ 'home.terms.paragraph3.part1' | translate }}
            <a class="text-link" href="mailto:info@d-carbonize.eu">info&#64;d-carbonize.eu</a>
            {{ 'home.terms.paragraph3.part2' | translate }}
        </p>
        <div class="form-choice">
            <p-checkbox inputId="terms-checkbox" [(ngModel)]="termsAccepted" [binary]="true"></p-checkbox>
            <label for="terms-checkbox">
                {{ 'home.terms.checkbox' | translate }}
            </label>
        </div>
        @if (submitted && !termsAccepted) {
            <small class="p-error block">{{ 'common.forms.validationMessages.required' | translate }}</small>
        }
    </div>
    <div class="form-actions terms__actions">
        <p-button [label]="'home.terms.accept' | translate" [loading]="loading" (onClick)="onSubmit()" />
    </div>
</div>
